import PropTypes from 'prop-types';
import React from 'react';

import CustomerDAO from '../customers/CustomerDAO';
import OrderDAO from '../orders/OrderDAO';

class EbizCheckout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: null,
      isLoading: true,
      paymentUrl: '',
    };
  }

  componentDidMount = async () => {
    const { customer_id } = this.props;

    // Fetch customer details (you might already have this part set up)
    const { customer } = await CustomerDAO.get_customer(customer_id);
    this.setState({ isLoading: false, customer });

    // Fetch the payment URL from OrderDAO
    const paymentData = { customer_id }; // Data you want to send with the request
    const response = await OrderDAO.get_ebiz_payment_url(this.props.order_id, paymentData);

    if (response && response.url) {
      this.setState({ paymentUrl: response.url }); // Store the URL in state
    }
  }; 

  render() {
    const { customer_id, order_id } = this.props;
    const { customer, isLoading, paymentUrl } = this.state;

    if (isLoading || !customer || customer.payment_method_code !== 'EBC') {
      return null;
    }

    return (
      <div>
        <h3>Pay by Ebiz Charge</h3>
        <p>Customer ID: {customer_id}</p>
        <p>Order ID: {order_id}</p>

        {/* Conditionally render the link */}
        {paymentUrl && (
          <div>
            <p>Click the link below to complete your payment:</p>
            <a href={paymentUrl} target="_blank" rel="noopener noreferrer">
              Complete Payment
            </a>
          </div>
        )}
      </div>
    )
  }
}

EbizCheckout.propTypes = {
  customer_id: PropTypes.number.isRequired,
  order_id: PropTypes.number.isRequired,
}

export {EbizCheckout};